module.exports = "/img/27.0ea592.webp";